export default __webpack_public_path__ + "postgresql.3ffb4cfb.png";